import { WalletAdapterNetwork } from '@solana/wallet-adapter-base'
import { Wallet } from '@solana/wallet-adapter-react'
import {
  BitgetWalletAdapter,
  LedgerWalletAdapter,
  PhantomWalletAdapter,
  SolflareWalletAdapter,
  TokenPocketWalletAdapter,
  TorusWalletAdapter,
  WalletConnectWalletAdapter
} from '@solana/wallet-adapter-wallets'

import { Description, Icon, Name } from '@/constants/manifast'

import { OkxWalletAdapter } from './OKXWalletAdapter'
import { OkxWalletUIAdapter } from './OkxWalletUIAdapter'
import { TrustWalletAdapter } from './TrustWalletAdapter'

const _walletConnect = () => {
  const connectWallet: WalletConnectWalletAdapter[] = []
  try {
    connectWallet.push(
      new WalletConnectWalletAdapter({
        network: WalletAdapterNetwork.Mainnet,
        options: {
          projectId: import.meta.env.VITE_PROJECT_ID,
          metadata: {
            name: Name,
            description: Description,
            url: location.origin,
            icons: [Icon]
          }
        }
      })
    )
  } catch {
    // console.error('WalletConnect error', e)
  }
  return connectWallet
}

const appWallets = [
  new OkxWalletUIAdapter()
  // ..._walletConnect()
]

export const isAppWallet = (wallet: Wallet) =>
  wallet.adapter instanceof OkxWalletUIAdapter ||
  wallet.adapter instanceof WalletConnectWalletAdapter

const commonWallets = [
  new PhantomWalletAdapter(),
  new OkxWalletAdapter(),
  new SolflareWalletAdapter(),
  new TrustWalletAdapter(),
  new TokenPocketWalletAdapter(),
  new BitgetWalletAdapter(),
  new TorusWalletAdapter({ params: {} }),
  new LedgerWalletAdapter()
]

export const wallets = [...appWallets, ...commonWallets]
